// src/components/career/CareerCard.jsx

export default function CareerCard({ image, title }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-lg transition cursor-pointer">
      <img
        src={image}
        alt={title}
        className="w-full h-auto object-cover"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
